import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ListView from "../../../utils/Custom/listView";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { submitSiteDelete } from "../../../utils/commonComponent/delete";
import { AddButton, DeleteButton } from "../../../utils/Custom/Button";
import { toast } from "react-toastify";
import { AutoCompletes } from "../../../utils/Custom/custominput";
import { getPermissions } from "../rbac/hasAccess";

const headers = ["id", "documentType", "Name", "assignuserID"];

const fields = [{ value: "documentType", label: "Document" }, { value: "Name", label: "Name" }];

const DocumentLibraryMasterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/documentLibrary/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("documentLibrary", row.id);
  const userType = localStorage.getItem("type") || "";
  const [selectedOuterID, setSelectedOuterID] = React.useState([]);
  const [empList, setEmpList] = useState([]);
  const [selectedEmpId, setEmpId] = useState([]);
  const [documentLibraryList, setDocumentLibraryList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "documentType");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const inspectorId = localStorage.getItem("id") || "";

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  const handleMultipleDelete = () => {
    submitSiteDelete("documentLibrary", selectedOuterID);
  };

  const getWhereClause = () => {
    let whereConditions = "";
    const colMap = {
      documentType: "documentType",
      Name: "Name",
    };
    const colName = colMap[searchBy];
    if (searchBy && searchKey.trim()) {
      whereConditions = `WHERE LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
    }

    if (userType === "2") {
      if (whereConditions) {
        whereConditions += ` AND assignuserID LIKE '%${inspectorId}%'`;
      } else {
        whereConditions = `WHERE assignuserID LIKE '%${inspectorId}%'`;
      }
    }

    return whereConditions;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();
    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)}`;
    }
    return `SELECT * FROM documentLibrary ${whereClause} ORDER BY id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();
    return `SELECT COUNT(*) AS totalRows FROM documentLibrary ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [DlData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      const Data = DlData || [];
      const updatedUserData = Data.map((row) => {
        const inspectorIds = row.assignuserID
          ? row.assignuserID.split(",").map((id) => id.trim())
          : [];
        const displayedNames = inspectorIds
          .slice(0, 5)
          .map((id) => empList.find((emp) => emp.id === parseInt(id))?.name || "")
          .filter(Boolean)
          .join(",");
        const etcText = inspectorIds.length > 5 ? ",etc..." : "";
        return { ...row, assignuserID: displayedNames + etcText };
      });

      setDocumentLibraryList(updatedUserData);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchinpectorsList = async () => {
    const query = `SELECT u.*, emp.name FROM users u LEFT JOIN employees emp ON u.employeeId = emp.id WHERE u.status = 1 and u.type = 2 ORDER BY u.id DESC`;
    const res = await fetchQuery(query);
    setEmpList(res);
  };

  const assignEmployee = async () => {
    if (!selectedEmpId.length) {
      alert("Please select an Employee.");
      return;
    }

    const idsToUpdate = selectedOuterID.join(",");
    const inspectorIds = selectedEmpId.join(",");

    try {
      const query = `UPDATE documentLibrary SET assignuserID = '${inspectorIds}' WHERE id IN (${idsToUpdate})`;
      await fetchQuery(query);
      toast.success("Inspectors assigned successfully!");
      window.location.reload();
    } catch (err) {
      console.error("Failed to assign employees:", err);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("documentType");
    setSearchKey("");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [empList, currentPage, rowsPerPage]);

  useEffect(() => {
    fetchinpectorsList();
  }, []);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(userType == 1 || (permissions.create || permissions.allAccess)) && (
        <AddButton
          id="btn-add-outline"
          to="/master/documentLibrary/0"
          label="Add Document Library"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        title="Search Document Library"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      {selectedOuterID.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-10 my-3 mb-5 ">
          <DeleteButton
            id="btn-multi-delete"
            label="Multiple Delete"
            onClick={handleMultipleDelete}
          />
          <AutoCompletes
            label="Choose Employee"
            options={empList}
            value={selectedEmpId}
            onChange={(val) => setEmpId(val)}
            isWidth
            multiple
            valueKey="id"
            labelKey="name"
            limitTags={1}
          />
          <AddButton
            id="btn-assign-employee"
            label="Assign Inspector"
            onClick={assignEmployee}
          />
        </div>
      )}

      <ListView
        headers={headers}
        data={documentLibraryList}
        actions={{
          edit: userType == 1 && handleEdit,
          delete: handleDelete,
          view: (row) => row.filePathUrl ? window.open(row.filePathUrl) : toast.warn("No file"),
        }}
        showCheckbox={true}
        setSelectedOuterID={setSelectedOuterID}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default DocumentLibraryMasterList;